import { lazyWithPreload } from 'react-lazy-with-preload';

const PostListPage = lazyWithPreload(() => import('./pages/progress-line-post-list/Page'));

const Routes = [
    {
        path: 'progress-line',
        element: <PostListPage />,
    },
];

export default Routes;
